class MiniCart extends HTMLElement {
  constructor() {
    super();

    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    const summaryElement = this.drawer.querySelector('summary');
    summaryElement.click();

    setTimeout(() => {
      setHeaderHeight();
    }, 250);
  }

  renderContents(parsedState) {
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);

/* SAIL · Carrito "Completá tu envío" (Denim Week) */
(function () {
  if (window.__sailEnvioUpsell) return;
  window.__sailEnvioUpsell = true;

  function sectionHTML(html) {
    var el = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
    return el ? el.innerHTML : null;
  }

  function closeAll() {
    document.querySelectorAll('.sail-ew__talles').forEach(function (s) { s.hidden = true; });
    document.querySelectorAll('[data-sail-ew-toggle]').forEach(function (b) {
      b.hidden = false;
      b.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-sail-ew-toggle]');
    if (toggle) {
      event.preventDefault();
      var card = toggle.closest('.sail-ew__card');
      var sizes = card && card.querySelector('.sail-ew__talles');
      if (!sizes) return;
      closeAll();
      sizes.hidden = false;
      toggle.hidden = true;
      toggle.setAttribute('aria-expanded', 'true');
      var first = sizes.querySelector('button:not([disabled])');
      if (first) first.focus();
      return;
    }

    var size = event.target.closest('[data-sail-ew-variant]');
    if (!size || size.disabled) return;
    event.preventDefault();

    var card = size.closest('.sail-ew__card');
    var error = card.querySelector('.sail-ew__error');
    if (error) error.hidden = true;
    card.classList.add('is-loading');

    var addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: Number(size.dataset.sailEwVariant),
          quantity: 1,
          properties: { _origen: 'carrito_envio_gratis' }
        }],
        sections: 'mini-cart,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || 'No se pudo agregar');
          return data;
        });
      })
      .then(function (data) {
        var sections = data.sections || {};
        var miniCart = document.getElementById('mini-cart');
        var bubble = document.getElementById('cart-icon-bubble');
        if (miniCart && sections['mini-cart']) miniCart.innerHTML = sectionHTML(sections['mini-cart']);
        if (bubble && sections['cart-icon-bubble']) bubble.innerHTML = sectionHTML(sections['cart-icon-bubble']);
        document.dispatchEvent(new CustomEvent('sail:cart-changed'));

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'carrito_envio_gratis_add',
          item_list_name: 'carrito_envio_gratis',
          item_name: size.dataset.name,
          item_variant: size.dataset.variantTitle,
          price: Number(size.dataset.price) / 100
        });
      })
      .catch(function (e) {
        console.error(e);
        card.classList.remove('is-loading');
        if (error) error.hidden = false;
      });
  });
})();
